import { DELETE_COLLABORATOR_ROLE, DESTROY_BACKDROP, FETCH_ROLES_AND_ACCESS, FETCH_ROLES_AND_ACCESS_LOADING, FETCH_SCREENS_AND_FEATURES, FETCH_SCREENS_AND_FEATURES_LOADING, OPEN_BACKDROP, UPDATE_COLLABORATOR_ROLE_CHANGES } from '../../actions/types';



// const initialState = {
//   rolesAndAccessDetails: {
//     status: false,
//     rolesAndAccessDashboard: [],
//     errorDescription: '',
//   },
// };

// const rolesAndAccessReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case FETCH_ROLES_AND_ACCESS:
//       return {
//         ...state,
//         rolesAndAccessDetails: action.payload,
//       };

//     default:
//       return state;
//   }
// };
// Redux action example
//export default rolesAndAccessReducer;



const initialState = {
  rolesAndAccessDetails: {
    status: false,
    rolesAndAccessDashboard: [],
    errorDescription: '',
    totalNoOfRecords: 0,
    numberOfPages: 0,
    message: '',
  },
};

const rolesAndAccessReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ROLES_AND_ACCESS:
      return {
        ...state,
        rolesAndAccessDetails: action.payload,  // Update the state with the fetched data
      };
      case FETCH_ROLES_AND_ACCESS_LOADING:
      return {
        ...state,
        rolesAndAccessDetailsLoading: action.payload,  // Update the state with the fetched data
      };
      case FETCH_SCREENS_AND_FEATURES:
        return {
          ...state,
          screensAndFeatureDetails: action.payload,  // Update the state with the fetched data
        };
        case FETCH_SCREENS_AND_FEATURES_LOADING:
          return {
            ...state,
            screensAndFeatureDetailsLoading: action.payload,  // Update the state with the fetched data
          };
          case UPDATE_COLLABORATOR_ROLE_CHANGES:
            return {
              ...state,
              updateCollaboratorRole: action.payload,  // Update the state with the fetched data
            };
            case DELETE_COLLABORATOR_ROLE:
              return {
                ...state,
                deleteCollaboratorRole: action.payload,  // Update the state with the fetched data
              };
                  case OPEN_BACKDROP:
                    return {
                      ...state,
                      backdropLoading: true,
                      backdropText: action.backdropText
                        ? action.backdropText
                        : `Please don't refresh or close the tab while processing`,
                    };
              
                  case DESTROY_BACKDROP:
                    return {
                      ...state,
                      backdropLoading: false,
                    };
    default:
      return state;
  }
};

export default rolesAndAccessReducer;

